export default __webpack_public_path__ + "static/media/alex-blajan-iRsktlI-hls-unsplash.649ea38e.jpg";